<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('price_lists')">Cenniki</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('price_lists.edit', {'price_list':price_list.id})">{{ price_list.name }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowa pozycja cennika
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="store" class="z-0" v-if="price_list.type_id < 4">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <shtax-checkbox class="pr-6 pb-8 w-full" v-model:checked.sync="form.is_simple_item" :error="form.errors.is_simple_item" :checked="form.is_simple_item" :label="'Pozycja prosta (Opis + Cena netto)'" v-if="price_list.type_id < 3" />

          <template v-if="price_list.type_id == 3 || form.is_simple_item">
            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.description" :error="form.errors.description" label="Opis" />

            <text-input v-model="form.fv_pos_value" :error="form.errors.fv_pos_value" class="pr-6 pb-8 w-full lg:w-1/3" label="Cena netto pozycji" type="number" step="0.01" />
            <shtax-checkbox class="lg:mt-8 pr-6 pb-8 w-full lg:w-1/2" v-model:checked.sync="form.is_min_price_value" :error="form.errors.is_min_price_value" :checked="form.is_min_price_value" :label="'Podana cena netto jest ceną minimalną za usługę'"  />

          </template>
          <template v-if="price_list.type_id < 3 && !form.is_simple_item">

            <text-input v-model="form.min_num_of_docs" :error="form.errors.min_num_of_docs" class="pr-6 pb-8 w-full lg:w-1/3" label="Min. liczba dokumentów" type="number" min="0" />
            <text-input v-model="form.max_num_of_docs" :error="form.errors.max_num_of_docs" class="pr-6 pb-8 w-full lg:w-1/3" label="Maks. liczba dokumentów" type="number" />
            <text-input v-model="form.fv_pos_value" :error="form.errors.fv_pos_value" class="pr-6 pb-8 w-full lg:w-1/3" label="Cena netto pozycji" type="number" step="0.01" />

            <shtax-checkbox class="lg:mt-6 pr-6 pb-8 w-full lg:w-1/2" v-model:checked.sync="form.is_per_docs" :error="form.errors.is_per_docs" :checked="form.is_per_docs" :label="'Dodatkowa opłata za każdy dokument powyżej: '+ (form.min_num_of_docs-1)"  />
            <template v-if="form.is_per_docs">
                <text-input v-model="form.per_doc_value" :error="form.errors.per_doc_value" class="pr-6 pb-8 w-full lg:w-1/2" label="Cena netto za dokument" type="number" step="0.01" />
            </template>

          </template>

          

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center rounded-b-md">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Dodaj pozycję</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'

export default {
  metaInfo: { title: 'Nowa pozycja cennika' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput
  },
  layout: Layout,
  props: {
    price_list: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        description: '',
        min_num_of_docs: 1 +'',
        max_num_of_docs: 1 +'',
        fv_pos_value: null,
        is_per_docs: false,
        per_doc_value: null,
        is_simple_item: false,
        is_min_price_value: false,
      })
    }
  },
  methods: {
    store() {
      this.form.post(this.route('price_lists.items.store', {'price_list': this.price_list.id}))
    },
  }
}
</script>
